<!--
  ConfettiCanvas — a single confetti throw on a transparent canvas: pieces fan upward from
  the origin (the character's hands, as a fraction of the box) then tumble down under gravity
  and fade. Inert under prefers-reduced-motion or without a 2D context. The parent positions
  and sizes it; the canvas only fills that box.
-->
<template>
  <canvas ref="canvas" class="confetti" aria-hidden="true" />
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useConfetti } from '../composables/useConfetti'

const props = withDefaults(defineProps<{ originX?: number; originY?: number; count?: number }>(), {
  originX: 0.5,
  originY: 0.22,
  count: 140,
})
const canvas = ref<HTMLCanvasElement | null>(null)
useConfetti(canvas, { originX: props.originX, originY: props.originY, count: props.count })
</script>

<style scoped>
.confetti {
  display: block;
  width: 100%;
  height: 100%;
  pointer-events: none;
}
</style>
